import { BASE_URL } from "config";
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  Input,
  IconButton,
  Autocomplete,
  InputLabel,
} from "@mui/material";
import dayjs from "dayjs";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import Swal from "sweetalert2";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
import { Image } from "@mui/icons-material";
import { useGetStoreInfoQuery } from "../../../redux/Slices/storeInfoApi";
import { set } from "date-fns";
const targetTypes = [
  { value: "url", label: "رابط" },
  { value: "product", label: "منتج" },
  { value: "category", label: "فئة" },
  { value: "store", label: "مزود" },
  { value: "event", label: "فعالية" },
];

const AddAdsForm = ({ onClose, onSuccess, initialData }) => {
  const { data: Info, loading: loadingStore } = useGetStoreInfoQuery();
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    title: initialData?.title || "",
    image: initialData?.image || null,
    target_type: initialData?.target_type || "",
    target_id: initialData?.target_id || "",
    target_url: initialData?.target_url || "",
    context_id: initialData?.context_id || 1,
    starts_at: initialData?.starts_at || "",
    ends_at: initialData?.ends_at || "",
    id: initialData?.id || null,
  });
  console.log("formData,", formData);
  const [contexts, setContexts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [vendor, setVendor] = useState();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  console.log("sssssssssssss", Info);
  console.log("store_id", Info?.data?.store_id);

  // جلب البيانات من API واحد
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.get(BASE_URL + "/manager/ads/create", {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("addddddds", response.data);
        setCategories(response.data.data.categories || []);
        setProducts(response.data.data.products || []);

        setEvents(response.data.data.events || []);
        setContexts(response.data.data.contexts || []);
      } catch (error) {
        setCategories([]);
        setProducts([]);

        setEvents([]);
        setContexts([]);
      }
    };
    fetchData();
  }, []);

  // تحديث صورة المعاينة
  useEffect(() => {
    if (formData.image && typeof formData.image !== "string") {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(formData.image);
    } else if (typeof formData.image === "string") {
      setImagePreview(formData.image);
    } else {
      setImagePreview(null);
    }
  }, [formData.image]);

  // التحقق من الحقول الإلزامية
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "العنوان مطلوب";
    if (!formData.image) newErrors.image = "الصورة مطلوبة";
    if (!formData.target_type) newErrors.target_type = "نوع الإعلان مطلوب";
    if (!formData.context_id) newErrors.context_id = "الشاشة مطلوبة";
    // تحقق من الحقل الديناميكي
    if (formData.target_type === "url" && !formData.target_url)
      newErrors.target_url = "الرابط مطلوب";
    if (
      ["product", "category", "store", "event"].includes(formData.target_type) &&
      !formData.target_id
    ) {
      if (formData.target_type === "product") newErrors.target_id = "المنتج مطلوب";
      if (formData.target_type === "category") newErrors.target_id = "الفئة مطلوبة";

      if (formData.target_type === "event") newErrors.target_id = "الفعالية مطلوبة";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (formSubmitted) validateForm();
    // eslint-disable-next-line
  }, [formData]);

  // تغيير القيم
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.name === "target_type" && e.target.value === "store") {
      console.log("Info.data.store.store_id", Info.data.store_id);
      setFormData((prev) => ({ ...prev, [name]: value, target_id: Info.data.store_id }));
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // تغيير الصورة
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, image: file }));
  };
  // تغيير Autocomplete
  const handleAutoChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value && value.id ? value.id : "" }));
  };

  // دالة لتحويل datetime-local إلى الصيغة المطلوبة
  function formatDateTimeLocal(value) {
    console.log(value);
    if (!value) return "";
    // إذا كانت القيمة بدون ثواني (YYYY-MM-DDTHH:mm)
    if (value.length === 16) {
      return value.replace("T", " ") + ":00";
    }
    // إذا كانت القيمة مع ثواني (YYYY-MM-DDTHH:mm:ss)
    if (value.length === 19) {
      return value.replace("T", " ");
    }
    return value;
  }

  // create new advert
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    setFormSubmitted(true);
    if (!validateForm()) return;
    try {
      const formPayload = new FormData();
      // أضف الحقول مع تحويل التواريخ
      Object.entries(formData).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          key !== "id" &&
          key !== "starts_at" &&
          key !== "ends_at"
        ) {
          if (key === "image") {
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });
      // أضف التواريخ بعد تحويلها
      const startsAtFormatted = formatDateTimeLocal(formData.starts_at);
      const endsAtFormatted = formatDateTimeLocal(formData.ends_at);
      console.log("starts_at to API:", formData.starts_at);
      console.log("ends_at to API:", endsAtFormatted);
      formPayload.append("starts_at", startsAtFormatted);
      formPayload.append("ends_at", endsAtFormatted);
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/manager/ads/update/${formData.id}`
        : BASE_URL + "/manager/ads/store";
      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess && onSuccess();
        onClose && onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء الحفظ";
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  // إلغاء
  const handleCancel = () => {
    setFormData({
      title: "",
      image: null,
      target_type: "",
      target_id: "",
      target_url: "",
      context_id: "",
      starts_at: "",
      ends_at: "",
    });
    setErrors({});
    onClose && onClose();
  };

  // خيارات Autocomplete حسب نوع الإعلان
  let dynamicField = null;
  if (formData.target_type === "url") {
    dynamicField = (
      <FormControl fullWidth error={!!errors.target_url} sx={{ mb: 2 }}>
        <TextField
          label="الرابط المستهدف"
          name="target_url"
          value={formData.target_url}
          onChange={handleChange}
          error={!!errors.target_url}
          helperText={errors.target_url}
        />
      </FormControl>
    );
  } else if (formData.target_type === "product") {
    dynamicField = (
      <FormControl fullWidth error={!!errors.target_id} sx={{ mb: 2 }}>
        <Autocomplete
          options={products}
          getOptionLabel={(option) => option.name || ""}
          value={products.find((c) => c.id === formData.target_id) || ""}
          onChange={(_, newValue) => handleAutoChange("target_id", newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="اختر المنتج"
              error={!!errors.target_id}
              helperText={errors.target_id}
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </FormControl>
    );
  } else if (formData.target_type === "category") {
    dynamicField = (
      <FormControl fullWidth error={!!errors.target_id} sx={{ mb: 2 }}>
        <Autocomplete
          options={categories}
          getOptionLabel={(option) => option.name || ""}
          value={categories.find((c) => c.id === formData.target_id) || ""}
          onChange={(_, newValue) => handleAutoChange("target_id", newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="اختر الفئة"
              error={!!errors.target_id}
              helperText={errors.target_id}
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </FormControl>
    );
  } else if (formData.target_type === "store") {
    dynamicField = null;
  } else if (formData.target_type === "event") {
    dynamicField = (
      <FormControl fullWidth error={!!errors.target_id} sx={{ mb: 2 }}>
        <Autocomplete
          options={events}
          getOptionLabel={(option) => option.name || ""}
          value={events.find((c) => c.id === formData.target_id) || ""}
          onChange={(_, newValue) => handleAutoChange("target_id", newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="اختر الفعالية"
              error={!!errors.target_id}
              helperText={errors.target_id}
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </FormControl>
    );
  }

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل الإعلان" : "إضافة إعلان جديد"}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {/* Main Form */}
      <Box container spacing={2}>
        {/* صف العنوان والصورة */}
        <Box item xs={4}>
          <FormControl fullWidth error={!!errors.title} sx={{ mb: 2 }}>
            <TextField
              label="عنوان الإعلان"
              name="title"
              value={formData.title}
              onChange={handleChange}
              error={!!errors.title}
              helperText={errors.title}
            />
          </FormControl>
        </Box>

        {/* صف نوع الإعلان والشاشة */}
        <Box item xs={4}>
          <FormControl fullWidth error={!!errors.target_type} sx={{ mb: 2 }}>
            <InputLabel id="target-type-label">نوع الإعلان</InputLabel>
            <Select
              labelId="target-type-label"
              name="target_type"
              value={formData.target_type}
              label="نوع الإعلان"
              onChange={handleChange}
              error={!!errors.target_type}
              sx={{ height: "55px" }}
            >
              {targetTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
            {errors.target_type && <FormHelperText>{errors.target_type}</FormHelperText>}
          </FormControl>
        </Box>
        <Box item xs={4}>
          <FormControl fullWidth error={!!errors.context_id} sx={{ mb: 2 }}>
            <Autocomplete
              options={contexts}
              getOptionLabel={(option) => option.name || ""}
              value={contexts.find((c) => c.id === formData.context_id) || 1}
              onChange={(_, newValue) => handleAutoChange("context_id", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="اختر الشاشة"
                  error={!!errors.context_id}
                  helperText={errors.context_id}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>
        </Box>
        {/* صف الحقل الديناميكي */}
        {formData.target_type && (
          <Box item xs={4}>
            {dynamicField}
          </Box>
        )}
        {/* صف التواريخ */}

        {/* For Start Date with dayjs */}
        <Box item xs={4}>
          <FormControl fullWidth error={!!errors.starts_at} sx={{ mb: 2 }}>
            <TextField
              label="تاريخ البداية"
              type="date"
              name="starts_at"
              value={
                formData.starts_at
                  ? dayjs(formData.starts_at, "YYYY-MM-DD hh:mm:ss A").format("YYYY-MM-DD")
                  : ""
              }
              onChange={(e) => {
                const selectedDate = e.target.value;
                if (selectedDate) {
                  // Set to start of day and format to Y-m-d h:i:s A
                  const formattedDate = dayjs(selectedDate)
                    .startOf("day")
                    .format("YYYY-MM-DD hh:mm:ss A");

                  console.log("Formatted start date:", formattedDate);
                  setFormData((prev) => ({ ...prev, starts_at: formattedDate }));
                } else {
                  setFormData((prev) => ({ ...prev, starts_at: "" }));
                }
              }}
              error={!!errors.starts_at}
              helperText={errors.starts_at}
              InputLabelProps={{ shrink: true }}
            />
          </FormControl>
        </Box>

        {/*  For End Date with dayjs */}
        <Box item xs={4}>
          <FormControl fullWidth error={!!errors.ends_at} sx={{ mb: 2 }}>
            <TextField
              label="تاريخ النهاية"
              type="date"
              name="ends_at"
              value={
                formData.ends_at
                  ? dayjs(formData.ends_at, "YYYY-MM-DD hh:mm:ss A").format("YYYY-MM-DD")
                  : ""
              }
              onChange={(e) => {
                const selectedDateTime = e.target.value;
                if (selectedDateTime) {
                  // Extract date part, set to start of day, and format to Y-m-d h:i:s A

                  const formattedDate = dayjs(selectedDateTime)
                    .endOf("day")
                    .format("YYYY-MM-DD hh:mm:ss A");

                  console.log("Formatted end date:", formattedDate);
                  setFormData((prev) => ({ ...prev, ends_at: formattedDate }));
                } else {
                  setFormData((prev) => ({ ...prev, ends_at: "" }));
                }
              }}
              error={!!errors.ends_at}
              helperText={errors.ends_at}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 1 }}
            />
          </FormControl>
        </Box>
        {/* صف الصورة */}
        <Box item xs={4} display="flex" alignItems="center">
          <FormControl fullWidth error={!!errors.image} sx={{ mb: 2 }}>
            <InputLabel shrink htmlFor="image-upload">
              الصورة
            </InputLabel>
            <Input
              id="image-upload"
              type="file"
              inputProps={{ accept: "image/*" }}
              onChange={handleImageChange}
              sx={{ display: "none" }}
            />
            <label htmlFor="image-upload">
              <Button
                variant=""
                component="span"
                fullWidth
                startIcon={<CloudUploadIcon />}
                sx={{
                  height: 48,
                  fontWeight: "bold",
                  letterSpacing: 1,
                  bgcolor: "transparent",
                  /*  color: "white",
                  ":hover": { bgcolor: "primary.dark" }, */
                  mb: 1,
                }}
              >
                {formData.image ? "تغيير الصورة" : "تحميل صورة"}
              </Button>
            </label>
            {imagePreview && (
              <Box mt={1} display="flex" justifyContent="center">
                <img src={imagePreview} alt="preview" width={350} height={100} />
              </Box>
            )}
            {errors.image && <FormHelperText>{errors.image}</FormHelperText>}
          </FormControl>
        </Box>
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>
        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ px: 4, color: "white !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddAdsForm;
